__webpack_require__.p = "https://assets-dev.nextorder.co/build-assets/dev-build-2026-08-10-1786367518-stable-dev/";